import React from "react"
import { Box, Typography } from "@mui/joy"
import ThumbUpOutlinedIcon from '@mui/icons-material/ThumbUpOutlined'
import { useTranslation } from "react-i18next"

const SegmentConfirmation = ({ isCompleted = false }) => {
	const { t } = useTranslation()

	if (!isCompleted) return null

	return (
		<Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '300px' }}>
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					padding: 4,
					textAlign: 'center',
					mx: 'auto'
				}}
			>
				<Box>
					<ThumbUpOutlinedIcon sx={{ fontSize: 40, color: '#2196f3' }} />
				</Box>
				<Typography level="h4" sx={{ color: '#1976d2', fontWeight: 600, mb: 1 }}>
					{t('segmentSuccesfulCreation')}
				</Typography>
				<Typography level="body-lg" sx={{ color: '#546e7a' }}>
					{t('segmentSucessfulSubtitle')}
				</Typography>
			</Box>
		</Box>
	)
}

export default SegmentConfirmation
